"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APQRCode = _interopRequireDefault(require("../../../../common/APQRCode/APQRCode"));
var _depositWithdrawalHelper = require("../../../../../helpers/depositWithdrawalHelper");
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
require("./MarginCryptoDepositFormComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('margin-crypto-deposit');
var MarginCryptoDepositFormComponent = /*#__PURE__*/function (_React$Component) {
  function MarginCryptoDepositFormComponent() {
    _classCallCheck(this, MarginCryptoDepositFormComponent);
    return _callSuper(this, MarginCryptoDepositFormComponent, arguments);
  }
  _inherits(MarginCryptoDepositFormComponent, _React$Component);
  return _createClass(MarginCryptoDepositFormComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        selectDepositProduct = _this$props.selectDepositProduct,
        product = _this$props.product;
      selectDepositProduct(product.ProductId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.product.ProductId !== this.props.product.ProductId) {
        this.props.selectDepositProduct(this.props.product.ProductId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        selectedAddress = _this$props2.selectedAddress,
        product = _this$props2.product;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('container')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('body')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('col-left')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('title')
      }, t('Send cryptocurrency to this address.')), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('text')
      }, t('Your account will automatically update after the ' + 'cryptocurrency network confirms your transaction. ' + 'The confirmation may take up to 1 hour.'))), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('col-right')
      }, /*#__PURE__*/_react["default"].createElement(_APQRCode["default"], {
        value: "".concat((0, _depositWithdrawalHelper.getDepositType)(product), ":").concat(selectedAddress),
        size: 123
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('address-container')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('address-title')
      }, "Address:"), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('address-body')
      }, selectedAddress || t('no address provided'))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _reactI18next.withTranslation)('margin')(MarginCryptoDepositFormComponent);